export type TemplateType = 'default' | 'user' | 'shared' | 'blueprint';

export function isOrganisationTemplate(type: TemplateType): boolean {
  return type === 'default' || type === 'shared' || type === 'blueprint';
}

export interface Template {
  id: number;
  title: string;
  type: TemplateType;
  workflow_trigger: boolean;
  sections?: Record<string, { title?: string; instructions?: string; content?: string; text?: string }>;
}

export interface CopilotTemplatePayload {
  title: string;
  sections: Record<string, { instructions: string }>;
  workflow_trigger: boolean;
}
